import { endSession } from "../../helpers/sessionTimeout";

class LogoutService {
  static shared = new LogoutService();
  navigate = null;

  setNavigate(navigate) {
    this.navigate = navigate;
  }

  async logout() {
    endSession();
  }
}

export default LogoutService; 